import { render, staticRenderFns } from "./coursesDetail.vue?vue&type=template&id=5684636b&"
import script from "./coursesDetail.vue?vue&type=script&lang=js&"
export * from "./coursesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports